import { Injectable, Type } from '@angular/core';
import { EComponentType } from '../enumerables';
import { ShiftGroupComponent, MachineStatusByShiftComponent, MachineStatusGroupComponent } from '../components/custom-widget';
import { DashboardWidgetChartComponent } from '../components/dashboard-widget-chart/dashboard-widget-chart.component';
import { DashboardWidgetTableComponent } from '../components/dashboard-widget-table/dashboard-widget-table.component';
import { DashboardWidgetBasicComponent } from '../components/dashboard-widget-basic/dashboard-widget-basic.component';
import { StatusByMachineComponent } from '../components/custom-widget/status-by-machine/status-by-machine.component';
import { DrillsByMachineComponent } from '../components/custom-widget/drills-by-machine/drills-by-machine.component';
import { StatusFrontGroupComponent } from '../components/custom-widget/status-front-widget/status-front-group/status-front-group.component';
import { GeneralStatusSummaryGroupComponent } from '../components/custom-widget/general-status-summary-widget/general-status-summary-group/general-status-summary-group.component';
import { ProductionByHourComponent } from '../components/custom-widget/production-by-hour/production-by-hour.component';
import { ProductionByFrontComponent } from '../components/custom-widget/production-by-front/production-by-front.component';
import { OperationalDisciplineComponent } from '../components/custom-widget/operational-discipline/operational-discipline.component';
import { StatusByMachineGroupComponent } from '../components/custom-widget/status-by-machine-group-widget/status-by-machine-group/status-by-machine-group.component';
import { TrainMinuteByMinuteComponent } from '../components/custom-widget/train-minute-by-minute/train-minute-by-minute.component';
import { StatusByMachineTableComponent } from '../components/custom-widget/status-by-machine-table/status-by-machine-table.component';
import { LoopsByTrainComponent } from '../components/custom-widget/loops-by-train/loops-by-train.component';
import { LoopsByServiceTrainComponent } from '../components/custom-widget/loops-by-service-train/loops-by-service-train.component';
import { TransitLoopsBznComponent } from '../components/custom-widget/transit-loops-bzn/transit-loops-bzn.component';
import { ProductionByOperatorComponent } from '../components/custom-widget/production-by-operator/production-by-operator.component';
import { ProductionByStreetChartComponent } from '../components/custom-widget/production-by-street/production-by-street-chart/production-by-street-chart.component';
import { TotalExtractionComponent } from '../components/custom-widget/total-extraction/total-extraction.component';
import { ProductionEveryThirtyMinutesComponent } from '../components/custom-widget/production-every-thirty-minutes/production-every-thirty-minutes.component';
import { ProductionByMachineComponent } from '../components/custom-widget/production-by-machine/production-by-machine.component';
import { MinuteByMinuteComponent } from '../components/custom-widget/minute-by-minute/minute-by-minute.component';
import { StatusParkComponent } from '../components/custom-widget/status-park/status-park.component';
import { DetailDumpPointComponent } from '../components/custom-widget/detail-dump-point/detail-dump-point.component';
import { TotalChargeComponent } from '../components/custom-widget/total-charge/total-charge.component';
import { ProductionByTypetruckDumpPointComponent } from '../components/custom-widget/production-by-typetruck-dump-point/production-by-typetruck-dump-point.component';
import { TransferScoopComponent } from '../components/custom-widget/transfer-scoop/transfer-scoop.component';
import { ProductionTonsByHourComponent } from '../components/custom-widget/production-tons-by-hour/production-tons-by-hour.component';
import { GeneralDrillingComponent } from '../components/custom-widget/general-drilling/general-drilling.component';
import { DrillActivityTypeComponent } from '../components/custom-widget/drill-activity-type/drill-activity-type.component';
import { ProdVsPlanChartComponent } from '../components/custom-widget/production-vs-plan/prod-vs-plan-chart/prod-vs-plan-chart.component';
import { ProductionByChimneyComponent } from '../components/custom-widget/production-by-chimney/production-by-chimney.component';
import { TonsByOriginComponent } from '../components/custom-widget/tons-by-origin/tons-by-origin.component';
import { LoopsByOriginComponent } from '../components/custom-widget/loops-by-origin/loops-by-origin.component';
import { ProductionHourByModelTruckComponent } from '../components/custom-widget/production-hour-by-model-truck/production-hour-by-model-truck.component';
import { ProductionByTruckHourDayComponent } from '../components/custom-widget/production-by-truck-hour-day/production-by-truck-hour-day.component';
import { ProductionByModelTruckDumpPointComponent } from '../components/custom-widget/production-by-model-truck-dump-point/production-by-model-truck-dump-point.component';
import { DelayTimeTruckEmbeddedComponent } from '../components/custom-widget/delay-time-truck-embedded/delay-time-truck-embedded.component';
import { ProductionByTruckAndTolvaComponent } from '../components/custom-widget/production-by-truck-and-tolva/production-by-truck-and-tolva.component';

@Injectable({
  providedIn: 'root',
})
export class ComponentWidgetProviderService {
  /**
   * Returns the component of type requested
   *
   * @param type Type of widget component required
   */
  public get(type: EComponentType): Type<any> {
    switch (type) {
      case EComponentType.shift:
        return ShiftGroupComponent;
      case EComponentType.chart:
        return DashboardWidgetChartComponent;
      case EComponentType.table:
        return DashboardWidgetTableComponent;
      case EComponentType.machineStatusByShift:
        return MachineStatusByShiftComponent;
      case EComponentType.machineStatus:
        return MachineStatusGroupComponent;
      case EComponentType.statusByMachine:
        return StatusByMachineComponent;
      case EComponentType.perforationsByMachine:
        return DrillsByMachineComponent;
      case EComponentType.statusFront:
        return StatusFrontGroupComponent;
      case EComponentType.productionByHour:
        return ProductionByHourComponent;
      case EComponentType.statusSummary:
        return GeneralStatusSummaryGroupComponent;
      case EComponentType.productionByFront:
        return ProductionByFrontComponent;
      case EComponentType.operationalDiscipline:
        return OperationalDisciplineComponent;
      case EComponentType.statusByMachineGroup:
        return StatusByMachineGroupComponent;
      case EComponentType.StatusByMachineTableComponent:
        return StatusByMachineTableComponent;
      case EComponentType.loopsByTrain:
        return LoopsByTrainComponent;
      case EComponentType.trainMinuteByMinute:
        return TrainMinuteByMinuteComponent;
      case EComponentType.loopsByServiceTrain:
        return LoopsByServiceTrainComponent;
      case EComponentType.transitLoopsBzn:
        return TransitLoopsBznComponent;
      case EComponentType.lhdLoopsHours:
        return ProductionByHourComponent;
      case EComponentType.productionByOperator:
        return ProductionByOperatorComponent;
      case EComponentType.productionByStreet:
        return ProductionByStreetChartComponent;
      case EComponentType.totalExtraction:
        return TotalExtractionComponent;
      case EComponentType.ProductionEveryThirtyMinutesComponent:
        return ProductionEveryThirtyMinutesComponent;
      case EComponentType.productionByMachine:
        return ProductionByMachineComponent;
      case EComponentType.minuteByminute:
        return MinuteByMinuteComponent;
      case EComponentType.statusPark:
        return StatusParkComponent;
      case EComponentType.dumpPoints:
        return DetailDumpPointComponent;
      case EComponentType.totalCharge:
        return TotalChargeComponent;
      case EComponentType.truckTypeDumpPoint:
        return ProductionByTypetruckDumpPointComponent;
      case EComponentType.loopScoop:
        return TransferScoopComponent;
      case EComponentType.productionTonsByHour:
        return ProductionTonsByHourComponent;
      case EComponentType.generalDrilling:
        return GeneralDrillingComponent;
      case EComponentType.drillActivityType:
        return DrillActivityTypeComponent;
      case EComponentType.productionvsPlan:
        return ProdVsPlanChartComponent;
      case EComponentType.productionByChimney:
        return ProductionByChimneyComponent;
      case EComponentType.tonsByOrigin:
        return TonsByOriginComponent;
      case EComponentType.loopsByOrigin:
        return LoopsByOriginComponent;
      case EComponentType.productionByHourTruck:
        return ProductionHourByModelTruckComponent;
      case EComponentType.productionByHourDayTruck:
        return ProductionByTruckHourDayComponent;
      case EComponentType.productionByModelTruckDump:
        return ProductionByModelTruckDumpPointComponent;
      case EComponentType.DelayTimeTruckEmbedded:
        return DelayTimeTruckEmbeddedComponent;
      case EComponentType.ProductionByTruckAndTolva:
        return ProductionByTruckAndTolvaComponent;
      default:
        return DashboardWidgetBasicComponent;
    }
  }
}
